// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"134":"d62061081c88342f","194":"e5535607b172c15e","888":"155d3ea539ffee68"}[chunkId] + ".css";
};